import { PlaceBetResponse } from '@frontend/sports/types/betslip';
import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';

export class OverAskTrackingActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/over-ask/tracking`;

    private static readonly TRACK_PENDING = `${OverAskTrackingActions.ACTION_SCHEMA}/TRACK_PENDING`;
    private static readonly TRACK_CLOSE = `${OverAskTrackingActions.ACTION_SCHEMA}/TRACK_CLOSE`;
    private static readonly TRACK_REJECT_DIALOG_ACTION_DISMISS = `${OverAskTrackingActions.ACTION_SCHEMA}/TRACK_PENDING_REJECT_DIALOG_ACTION_DISMISS`;
    private static readonly TRACK_REJECT_DIALOG_ACTION_CANCEL = `${OverAskTrackingActions.ACTION_SCHEMA}/TRACK_PENDING_REJECT_DIALOG_ACTION_CANCEL`;
    private static readonly TRACK_TRADER_OFFER = `${OverAskTrackingActions.ACTION_SCHEMA}/TRACK_TRADER_OFFER`;
    private static readonly TRACK_ODDS_CHANGE = `${OverAskTrackingActions.ACTION_SCHEMA}/TRACK_ODDS_CHANGE`;

    static trackPending = createAction(OverAskTrackingActions.TRACK_PENDING);
    static trackClose = createAction(OverAskTrackingActions.TRACK_CLOSE, props<{ method: 'close x' | 'cancel' }>());
    static trackRejectDialogActionDismiss = createAction(OverAskTrackingActions.TRACK_REJECT_DIALOG_ACTION_DISMISS);
    static trackRejectDialogActionCancel = createAction(OverAskTrackingActions.TRACK_REJECT_DIALOG_ACTION_CANCEL);
    static trackTraderOffer = createAction(OverAskTrackingActions.TRACK_TRADER_OFFER);
    static trackOddsChange = createAction(OverAskTrackingActions.TRACK_ODDS_CHANGE, props<{ overAskResponse: PlaceBetResponse | null }>());
}
